import { z } from "zod";
import { FileTypeEnum } from "./files.js";
/** Строка документа (наряд или акт) */
export const DocumentLineSchema = z.object({
    id: z.number(),
    rowNumber: z.number().int(),
    rateNumber: z.string().nullable(),
    workName: z.string(),
    unit: z.string().nullable(),
    quantity: z.number().int(),
    rate: z.number().int(),
    k: z.number().nullable(),
    amount: z.number().int(),
    lineType: z.number().int().nullable(),
    section: z.number().int().nullable(),
});
/** Ответ со строками документа */
export const DocumentLinesResponseSchema = z.object({
    fileId: z.number(),
    fileType: FileTypeEnum,
    objectName: z.string().nullable(),
    periodMonth: z.number().int().nullable(),
    periodYear: z.number().int().nullable(),
    lines: z.array(DocumentLineSchema),
    summary: z.object({
        totalLines: z.number().int(),
        totalAmount: z.number().int(),
    }),
    total: z.number(),
    page: z.number(),
    pageSize: z.number(),
});
/** Ответ на запуск парсинга */
export const ParseTriggerResponseSchema = z.object({
    fileId: z.number(),
    status: z.string(),
    message: z.string(),
});
/** Параметры пагинации строк */
export const DocumentLinesQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(100),
});
//# sourceMappingURL=documents.js.map